export const environment = {
  production: false,
  apiUrl: 'https://dev.api.tesca.saint-gobain.com/api/',
  apiScope: 'api://1a1fb7c0-6da6-4112-9caa-d8dc528c2489/access_graph_on_behalf_of_user',
  enviromentName: 'TESCA-Dev',
  idleTimeout: 120000, /* 1000*60 *20 (20 minutes)*/
  refreshTokenTimeout: 1200000 /*seconds (1000*60*20) 20 minutes*/,
  isGoogleAnalyticsEnabled: false,
  isDevelopment: true,
  signInUsingSSOOnly: false,
  oidc: {
    clientId: '3a977022-b46a-490e-b769-59c604d2394b',
    authority: 'https://login.microsoftonline.com/e339bd4b-2e3b-4035-a452-2112d502f2ff',
     redirectUri: 'https://dev.tesca.saint-gobain.com',
    logoutUri: '/#/login'
  },
  sharepointUrl: "https://saintgobain.sharepoint.com/sites/FR-VETROTECH-TESCADocuments-UAT/",
  nomenclatureFilePath: "GlassDescr-Nomenclature/Glassdescr-nomenclature.xlsx?d=w97c63bdbdd8a4ed9a0716844d679b63f&csf=1&web=1&e=yBuflh"
};
